import DynamicWindowService from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service';
import AccessLevelMixin from '@/core/application-dictionary/mixins/AccessLevelMixin';
import { Component, Inject, Mixins, Vue } from 'vue-property-decorator';
import DashboardWidget from '../dashboard-widget.vue';

const VendorAddressProps = Vue.extend({
  props: {
    title: String
  }
});

@Component({
  components: {
    DashboardWidget
  }
})
export default class VendorAddress extends Mixins(AccessLevelMixin, VendorAddressProps) {

  @Inject('dynamicWindowService')
  protected commonService: (baseApiUrl: string) => DynamicWindowService;

  address: any = {};
  loading: boolean = false;

  created() {
    this.retreiveTaxAddress();    
  }

  editAddress() {
    console.log('editAddress')
    this.$router.push({
      path: 'bidding-management/address'
    });
  }

  retreiveTaxAddress() {
    this.loading = true;
    this.commonService('api/c-vendor-locations')
      .retrieve({
        criteriaQuery: this.updateCriteria(['active.equals=true', 'taxInvoiceAddress.equals=true']),
        paginationQuery: {
          page: 0,
          size: 1,
          sort: ['lastModifiedDate,desc']
        }
      })
      .then(res => {
        if (res.data.length) {
          this.address = res.data[0];
        }
      })
      .finally(() => this.loading = false);
  }
}